import { Store } from 'react-notifications-component'
import { logout } from '../actions/login'
import notificationConfig from '../config/notification'
import { ErrorsEnum } from './ErrorsEnum'
import { getPath } from '../MultilingualRouter/MultilingualRouter'
import Pages from '../Enum/Pages'

const displayNotification = (title, message) => {
  Store.addNotification({
    title,
    message,
    type: 'danger',
    ...notificationConfig
  })
}

const apiErrorHandler = (err, navigate, cmsErrors) => {
  const errorData = err?.response?.data?.errors?.[0]
  const getError = (errorCode) => cmsErrors?.find((error) => error.errorCode === errorCode.toString())

  if (err?.response?.status === ErrorsEnum?.ManyRequests) {
    const error = getError(ErrorsEnum?.ManyRequests)
    displayNotification(error?.title || 'Błąd przetwarzania danych', error?.message || 'Spróbuj ponownie za chwilę')
  } else if (err?.response?.status === ErrorsEnum?.Unauthorized) {
    const error = getError(ErrorsEnum?.ManyRequests)
    // WTF? Why redirect customer? That error code can happen on pages like contactForm that does not even require login
    if (window.location.pathname !== getPath(Pages.loginPage)) {
      navigate(getPath(Pages.loginPage))
      setTimeout(logout, 2500)
    }
    displayNotification(error?.title || 'Twoja sesja wygasła', error?.message || 'Zaloguj się ponownie')
  } else if (errorData?.detail) {
    displayNotification(errorData?.title, errorData?.detail)
  } else {
    displayNotification(undefined, errorData?.title)
  }
}

export default apiErrorHandler
